function InfoGlyph() {
  return (
    <svg className="gd-icon" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
      <circle cx="12" cy="12" r="10" />
      <path d="M12 16v-4" />
      <path d="M12 8h.01" />
    </svg>
  );
}

/**
 * The line above the Search results that says how the Request text was handled
 * (issue #22): either "Understood as: <title>" after a one-need analysis, or a
 * short note that the text was searched as written.
 *
 * `understoodAs` and `note` can carry raw AI output. They are rendered only as
 * React text nodes: never as HTML or markdown, and never in an href or style.
 */
export default function RequestNotice({ understoodAs, note }) {
  if (!understoodAs && !note) return null;

  if (understoodAs) {
    return (
      <div className="gd-notice gd-notice--accent">
        <span className="gd-notice__icon">
          <InfoGlyph />
        </span>
        <div className="gd-notice__body">
          <div className="gd-notice__title app-notice-text">Understood as: {understoodAs.title}</div>
          {understoodAs.description ? <div className="app-notice-text">{understoodAs.description}</div> : null}
        </div>
      </div>
    );
  }

  return (
    <div className="gd-notice" role="status">
      <span className="gd-notice__icon">
        <InfoGlyph />
      </span>
      <div className="gd-notice__body app-notice-text">{note}</div>
    </div>
  );
}
